import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MediaComponent } from '@shared/components/media/media.component';
import { TOASTER_TYPE, ToasterModel } from '@shared/components/toaster/toaster.model';
import { ToasterService } from '@shared/components/toaster/toaster.service';

@Component({
  selector: 'toaster-item',
  imports: [CommonModule, RouterModule, MediaComponent],
  templateUrl: './toaster-item.component.html',
  styleUrl: './toaster-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterItemComponent {
  @Input() toaster?: ToasterModel;
  TOASTER_TYPE = TOASTER_TYPE;

  constructor(private toasterService: ToasterService) {}

  closeIt(toasterID: string) {
    this.toasterService.closeIt(toasterID);
  }
}
